import { isTauri } from "@/lib/is-tauri";
import { getKnownFloatingFrameDisplayIds } from "./floating-frame-displays";
import { getWindowDisplayId } from "./use-window-role";
import { useActiveDisplay } from "./use-active-display";
import { shouldRenderDesktopToasts } from "@/lib/desktop-toast-visibility";

export function useDesktopToastVisibility(expandedDisplayId: number | null): boolean {
  const activeDisplayId = useActiveDisplay((s) => s.activeDisplayId);
  return shouldRenderDesktopToasts({
    isDesktop: isTauri(),
    myDisplayId: getWindowDisplayId(),
    activeDisplayId,
    expandedDisplayId,
    knownDisplayIds: getKnownFloatingFrameDisplayIds(),
  });
}
